import {Component, Inject, Input} from '@angular/core';
import {FormBuilder, FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {EmTranslatePipe} from '@emma-labs/shared/angular';
import {BOOLEAN_ANSWER_SELECT_BUTTONS, ENVIRONMENT, EnvironmentBroker} from '@emma-labs/shared/typescript';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CardModule} from 'primeng/card';
import {FileUploadModule} from 'primeng/fileupload';
import {SelectButtonModule} from 'primeng/selectbutton';
import {filter} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {BaseSectionComponent} from '../../base-section/base-section.component';

@UntilDestroy()
@Component({
  selector: 'em-replacement-notice-section',
  templateUrl: './replacement-notice-section.component.html',
  imports: [ReactiveFormsModule, CardModule, SelectButtonModule, FileUploadModule, EmTranslatePipe],
})
export class ReplacementNoticeSectionComponent extends BaseSectionComponent<
  FormControl<boolean | null>,
  boolean,
  {hasPolicyReplacementNotice: boolean; file?: File}
> {
  readonly booleanAnswerSelectButtons = BOOLEAN_ANSWER_SELECT_BUTTONS;

  files: File[] = [];

  constructor(
    private fb: FormBuilder,
    @Inject(ENVIRONMENT) environment: EnvironmentBroker,
  ) {
    super(environment);
    this.form = this.createForm();
  }

  @Input({required: true})
  override set props(hasPolicyReplacementNotice: boolean | undefined) {
    if (!this.isPropsReceived && hasPolicyReplacementNotice !== undefined) {
      super.props = hasPolicyReplacementNotice;
      if (hasPolicyReplacementNotice) {
        this.files = [new File([], 'replacement-notice.pdf')];
      }
    }
  }

  removeReplacementNotice(): void {
    this.files = [];
    this.propsChange.emit({
      output: {
        hasPolicyReplacementNotice: false,
      },
    });
  }

  addReplacementNotice(files: File[]): void {
    this.propsChange.emit({
      output: {
        hasPolicyReplacementNotice: true,
        file: files[0],
      },
      callback: (isSuccess: boolean) => {
        this.files = isSuccess ? [files[0]] : [];
      },
    });
  }

  needsFile(): boolean {
    return !!this.form.value && this.files.length === 0;
  }

  private createForm(): FormControl<boolean | null> {
    const form = this.fb.control<boolean | null>(null, [Validators.required]);

    form.valueChanges
      .pipe(
        filter(() => form.valid),
        distinctUntilChanged(),
        untilDestroyed(this),
      )
      .subscribe((value) => {
        if (!value) {
          this.removeReplacementNotice();
        }
      });
    return form;
  }
}
